var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99968 8.75008C4.4734 8.30118 3.98559 7.80905 3.54134 7.27883C2.87468 6.48258 2.08301 5.29675 2.08301 4.16675C2.08242 2.98656 2.79311 1.92233 3.88345 1.47066C4.9738 1.019 6.22887 1.26893 7.06301 2.10383C7.61153 2.64992 7.91881 3.39274 7.91636 4.16675C7.91636 5.29675 7.12468 6.48258 6.45801 7.27883C6.01377 7.80905 5.52595 8.30118 4.99968 8.75008ZM4.99968 2.91675C4.55309 2.91675 4.14043 3.155 3.91714 3.54175C3.69385 3.9285 3.69385 4.405 3.91714 4.79175C4.14043 5.1785 4.55309 5.41675 4.99968 5.41675C5.69003 5.41675 6.24968 4.8571 6.24968 4.16675C6.24968 3.47639 5.69003 2.91675 4.99968 2.91675Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLocationIcon);
export default __webpack_public_path__ + "static/media/resume-location-icon.2f007aeaf6e9c32a43a563e20383e7d9.svg";
export { ForwardRef as ReactComponent };